import { Dispatch, SetStateAction } from "react";
import { useSelectOptions } from "../../../../hooks/search";
import { SelectOption } from "../../../../types/select";
import { PropertyListQueryParams, PropertySearchBy } from "../types";

type UseBPropertiesSearchOptions = {
  selectedSearchBy: PropertySearchBy;
  setPropertyListParams: Dispatch<SetStateAction<PropertyListQueryParams>>;
};

export const usePropertiesSearch = (options: UseBPropertiesSearchOptions) => {
  const { selectedSearchBy, setPropertyListParams } = options;

  const { selectOptions } = useSelectOptions({ screen: "property", selectedSearchBy });

  function handleSearch(value: string) {
    setPropertyListParams((prev) => ({
      ...prev,
      searchValue: value || "",
    }));
  }

  function handleChangeSearchBy(option: SelectOption) {
    setPropertyListParams((prev) => ({
      ...prev,
      searchBy: String(option?.value) as PropertySearchBy,
      searchValue: "",
    }));
  }

  return { selectOptions, handleSearch, handleChangeSearchBy };
};
